import { ICaseLawDocument } from "../../../caseLawDocuments/model/CaseLawDocument";
import CaseLawDocumentMapper from "../../../caseLawDocuments/service/CaseLawDocumentMapper";
import CaseLawDocumentParamMapper from "../../../caseLawDocuments/service/CaseLawDocumentParamMapper";

import FindResourceEntryInteractor from "../../../core/interactor/app/crud/FindResourceEntryInteractor";
import Constants from "../../common/Constants";

export default class FindCaseLawDocumentInteractor {
  private resource: FindResourceEntryInteractor<ICaseLawDocument>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(
      Constants.caseLawDocumentPath,
      CaseLawDocumentMapper,
      CaseLawDocumentParamMapper,
      caseLawDocumentId
    );
  }
}
